/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '/assetManagerTransaction/list',
    name: 'AssetManagerTransaction',
    view: 'transaction/AssetManagerTransaction'
  },
  {
    path: '/transaction/add',
    name: 'TransactionAdd',
    view: 'transaction/TransactionAdd'
  },
  {
    path: '/emails',
    name: 'EmailTable',
    view: 'emails/EmailTable'
  },
  {
    path: '/templates',
    name: 'Templates',
    view: 'templates/TemplateManager'
  },
  {
    path: '/templateProducts',
    name: 'TemplatesProducts',
    view: 'templates/TemplateProducts'
  },
  {
    path: '/search',
    name: 'SearchResult',
    view: 'search/SearchResult'
  },
  {
    path: '/pricing',
    name: 'ProductPricingList',
    view: 'pricing/list'
  },
  {
    path: '/pricing/:id',
    name: 'ProductPricingDetails',
    view: 'pricing/single'
  },
  {
    path: '/products/types',
    name: 'Products',
    view: 'product/type/ProductTypeList'
  },
  {
    path: '/products/list',
    name: 'Products',
    view: 'product/ProductList'
  },
  {
    path: '/products/from/:issuerRelationId',
    name: 'ProductFromIssuerRelation',
    view: 'product/ProductForm',
    props: true
  },
  {
    path: '/products/duplicate/:productId',
    name: 'ProductDuplicate',
    view: 'product/ProductForm',
    props: true
  },
  {
    path: '/products/:id',
    name: 'ProductsEdit',
    view: 'product/ProductForm'
  },
  {
    path: '/product-import-batches',
    name: 'ProductImportBatches',
    view: 'productImportBatch/BatchList'
  },
  {
    path: '/product-import-batches/new',
    name: 'ProductImportBatchNew',
    view: 'productImportBatch/ImportWizard'
  },
  {
    path: '/product-import-batches/:id',
    name: 'ProductImportBatch',
    view: 'productImportBatch/ImportWizard',
    props: true
  },
  {
    path: '/assetManagers',
    name: 'AssetManagers',
    view: 'assetManagers/view'
  },
  {
    path: '/users/:userId/service-accounts',
    name: 'UserServiceAccounts',
    view: 'serviceAccounts/List'
  },
  {
    path: '/business-introducers',
    view: 'businessIntroducers/BusinessIntroducersList'
  },
  {
    path: '/stocks/:id/detail',
    name: 'Stock detail',
    view: 'stocks/detail/view'
  },
  {
    path: '/stocks/:id/mailings',
    name: 'Stocks Mailing',
    view: 'stocks/mailings'
  },
  {
    path: '/stocks/:id?',
    name: 'Stocks',
    view: 'stocks/view'
  },
  {
    path: '/prices/:type?/:id?',
    name: 'Prices',
    view: 'prices/Prices'
  },
  {
    path: '/invoice',
    view: 'invoice/InvoiceView'
  },
  {
    path: '/diagnostics',
    name: 'Diagnostics',
    view: 'Diagnostics/view'
  },
  {
    path: '/corporate-actions',
    name: 'Corporate actions',
    view: 'corporateActions/view'
  },
  {
    path: '/report-fields',
    name: 'Report fields',
    view: 'ReportFields/view'
  },
  {
    path: '/observations',
    name: 'Observations',
    view: 'observations/view'
  },
  {
    path: '/issuers',
    view: 'issuers/IssuersList'
  },
  {
    path: '/pricing-config',
    view: 'pricingConfig/PricingConfig'
  },
  {
    path: '/roles',
    view: 'roles/view'
  },
  {
    path: '/distribution-locations',
    view: 'distributionLocations/DistributionLocationsList'
  },
  {
    path: '/altitude-entities',
    view: 'altitudeEntities/view'
  },
  {
    path: '/brokers',
    view: 'brokers/view'
  },
  {
    path: '/custodians',
    view: 'custodians/CustodiansList'
  },
  {
    path: '/regulators',
    name: 'Regulators',
    view: 'regulators/view'
  },
  {
    path: '/products-v2/catalogue',
    name: 'ProductsV2Catalogue',
    view: 'productsV2/Catalogue'
  },
  {
    path: '/products-v2/catalogue/:name/:version',
    name: 'ProductsV2Template',
    view: 'productsV2/Template'
  },
  {
    path: '/products-v2/new',
    name: 'ProductsV2New',
    view: 'productsV2/NewProduct'
  },
  {
    path: '/products-v2/bricks',
    name: 'ProductsV2Bricks',
    view: 'productsV2/Bricks'
  },
  {
    path: '/products-v2/composer',
    name: 'ProductsV2Composer',
    view: 'productsV2/Composer'
  },
  {
    path: '/holidays',
    name: 'Holidays',
    view: 'holidays/List'
  }
]
